import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { login } from "../../../api/ApiConfig";
import { toast } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import { FiUser } from "react-icons/fi"; // Imported User Icon
import corevalue from "../../../images/core_value_new.png";
import santaSleigh from "../../../images/santa-sleigh.png"; // Make sure path is correct
import "../../global/Global.css";
import "../../global/GlobalStyle.css";
import "./Login.css";
import Loading from "../../loading/Loading";

export default function Login() {
  const [useremail, setUserEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  // 🎅 SANTA STATE
  const [santaX, setSantaX] = useState(-400);

  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
  }, []);

  /* 🎅 Santa Animation Loop */
  useEffect(() => {
    const start = performance.now();
    const duration = 22000; // 22 seconds to cross screen
    let frame;

    const animate = (now) => {
      const elapsed = (now - start) % duration;
      const progress = elapsed / duration;
      // Calculate position based on screen width
      setSantaX(window.innerWidth * progress - 250);
      frame = requestAnimationFrame(animate);
    };

    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!useremail.trim()) {
      toast.error("Email is required");
      return;
    }

    if (!password.trim()) {
      toast.error("Password is required");
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append("username", useremail);
    formData.append("password", password);
    formData.append("grant_type", "password");
    formData.append("scope", "");
    formData.append("client_id", "");
    formData.append("client_secret", "");

    try {
      await new Promise((resolve, reject) => {
        login(formData, (response) => {
          try {
            if (response.success === true) {
              Cookies.set("access_token", response.access_token, { expires: 1 });
              Cookies.set("refresh_token", response.refresh_token, { expires: 7 });
              Cookies.set("sid", response.sid, { expires: 1 });
              Cookies.set("userid", response.userid, { expires: 1 });
              localStorage.setItem("email", response.email);
              localStorage.setItem("emp_id", response.emp_id);

              toast.success("Login successful");
              navigate("/home");
              resolve();
            } else {
              toast.error(response.message || "Invalid credentials");
              reject(new Error(response.message || "Login failed"));
            }
          } catch (error) {
            reject(error);
          }
        });
      });
    } catch (err) {
      toast.error(err.message || "Login failed");
    } finally {
      setIsLoading(false);
    }
  };

  // Inline styles for Icons
  const iconStyle = {
    position: "absolute",
    right: "15px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#9d9d9d",
    fontSize: "20px",
    cursor: "pointer",
    zIndex: 2,
  };

  const inputContainerStyle = {
    position: "relative",
    width: "100%",
  };

  return (
    <>
      {isLoading && <Loading />}


      <div className={`box-describe ${isLoading ? "loading-active" : ""}`}>
        <div className="box-describe-wrapper">
          {/* Left side view */}
          <div className="box-describe-left-view">
            <div className="header">
              <p className="title">Sign In</p>
            </div>
            <form onSubmit={handleLogin}>
              
              {/* Email Input */}
              <div>
                <div className="input-field-global-field">
                  <label className="label-text" style={{ color: "#6E6E6E" }}>
                    Email or Emp Id
                  </label>
                  <div style={inputContainerStyle}>
                    <input
                      type="text"
                      id="loginemail"
                      value={useremail}
                      placeholder="Enter Email/Emp Id"
                      onChange={(e) => setUserEmail(e.target.value)}
                      autoComplete="off"
                      disabled={isLoading}
                      // Add paddingRight so text doesn't hit the icon
                      style={{ paddingRight: "40px" }} 
                    />
                    {/* Inline CSS Icon at the end */}
                    <FiUser style={{ ...iconStyle, cursor: "default" }} />
                  </div>
                </div>
              </div>

              {/* Password Input */}
              <div className="input-field-global-field">
                <label className="label-text" style={{ color: "#6E6E6E" }}>
                  Password
                </label>
                <div style={inputContainerStyle}>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    autoComplete="off"
                    disabled={isLoading}
                    style={{ paddingRight: "40px" }}
                  />
                  {/* Inline CSS Icon at the end */}
                  <div
                    style={iconStyle}
                    onClick={!isLoading ? togglePasswordVisibility : undefined}
                  >
                    {showPassword ? <IoIosEye /> : <IoIosEyeOff />}
                  </div>
                </div>
              </div>

              <div
                className="forget-remember"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 10,
                }}
              >
                <a
                  href={isLoading ? "#" : "/forget-password"}
                  style={{
                    color: "#7565B5",
                    fontSize: "16px",
                    fontWeight: 600,
                    pointerEvents: isLoading ? "none" : "auto",
                    opacity: isLoading ? 0.6 : 1,
                  }}
                >
                  Forgot password?
                </a>
              </div>

              <div className="button-design-container">
                <button
                  className={`button-design ${isLoading ? "button-loading" : ""}`}
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="button-spinner"></span>
                      Logging in...
                    </>
                  ) : (
                    "Login"
                  )}
                </button>
              </div>
            </form>
          </div>

          {/* Right side view */}
          <div className="box-describe-form-right-view">
            <div className="content-container">
              <div className="">
                <h3 className="corevaluehead">Our Vision</h3>
                <p className="corevaluesubhead">
                  To become a global IT Services and Solutions provider,
                  delivering innovation-led best-in-class technology solutions
                  by leveraging data, AI, and emerging technologies.
                </p>
              </div>
            </div>
            <div className="mt-4">
              <h3 className="corevaluehead">Our Mission</h3>
              <p className="corevaluesubhead">
                To co-engineer excellence for our customers with their
                transformation journey and in the process create value for all
                our stakeholders.
              </p>
            </div>

            <div className="mt-4">
              <img
                src={corevalue}
                alt="Illustration"
                className="img-container"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}